import Request from "components/Request";
import { Dashboard } from "components/Dashboard";
import { returnToMatchmaking, returnToMatchView } from "react/redux/actions/matchmaking";
import askForConnectionType, { needsConnectionType } from "react/matchmaking/connection/askForConnectionType";
import { showToast } from 'react/toasts/showToast';

export const ADD_GAME_TYPE_PENDING = 'ADD_GAME_TYPE_PENDING';
export const REMOVE_GAME_TYPE_PENDING = 'REMOVE_GAME_TYPE_PENDING';

export const IS_SUBMITTING_SEARCHES = 'IS_SUBMITTING_SEARCHES';
export const IS_NOT_SUBMITTING_SEARCHES = 'IS_NOT_SUBMITTING_SEARCHES';

export const SET_SELECTED_GAME_TYPE = 'SET_SELECTED_GAME_TYPE';


export const setSelectedGameType = (gameTypeId) => ({
	type: SET_SELECTED_GAME_TYPE,
	payload: gameTypeId,
});

export const addGameTypePending = (playOption) => {
	return {
		type: ADD_GAME_TYPE_PENDING,
		payload: playOption.toString()
	};
};

export const removeGameTypePending = (playOption) => {
	return {
		type: REMOVE_GAME_TYPE_PENDING,
		payload: playOption.toString()
	};
};

export const updateIsSubmittingSearches = (setTo) => {
	if(setTo) {
		return {
			type: IS_SUBMITTING_SEARCHES
		};
	}

	return {
		type: IS_NOT_SUBMITTING_SEARCHES,
	};
};

// onSearchErrors(refusals), when given, receives the refused searches
// ({ ladderId, message, duplicateSearch, searchId }) in place of a toast.
export const gameTypeClick = (playOptions, title = null, autoQueueValue = 0, onSearchErrors = null) => (dispatch, getState) => {
	const { submittingSearches } = getState().matchSelection;

	if(submittingSearches) {
		console.error('already submitting..');
		return Promise.resolve();
	}
	console.log('the options', playOptions);
	let type = null;
	const submissions = [];
	_.each(playOptions, (playOption) => {
		const data = {};
		data.team_size = playOption.teamSize;
		data.match_count = playOption.gameCount;
		data.ranked = playOption.isRanked;
		data.ladder_id = playOption.ladderId;
		data.player_id = playOption.playerId;
		data.auto_queue_setting = autoQueueValue;
		data.title = title;

		dispatch((addGameTypePending(playOption)));

		if(data.player_id) {
			type = 'challenge';
		} else {
			type = 'search';
		}
		const endpoint = data.player_id ? 'matchmaking/challenge_player' : 'matchmaking/start';

		submissions.push(Request.apiv1(endpoint, data)
			.catch((error) => {
				let errorData = null;
				if(error.responseJSON) {
					errorData = error.responseJSON;
				} else {
					errorData = error;
				}
				return { hadError: true, error: errorData };
			}));
	});
	const success = (response) => {
		Dashboard.performOpenSearchUpdate(response);
		dispatch(returnToMatchmaking());
	};
	const finished = () => {
		_.each(playOptions, (playOption) => {
			dispatch(removeGameTypePending(playOption));
		});

		dispatch(updateIsSubmittingSearches(false));
	};

	dispatch(updateIsSubmittingSearches(true));
	if(type === 'challenge') {
		return submissions[0]
			.then(success)
			.catch((error) => {
				console.log('got to eerror2??', error);
				Request.generalJsonError(error);
			})
			.finally(finished);

	} else {
		return Promise.all(submissions)
			.then(results => {
				if(results.some((result) => result && result.hadError && needsConnectionType(result.error))) {
					return askForConnectionType().then((connectionType) => {
						if(!connectionType) {
							return undefined;
						}
						dispatch(updateIsSubmittingSearches(false));
						return dispatch(gameTypeClick(playOptions, title, autoQueueValue, onSearchErrors));
					});
				}

				let mostImportantError = null;
				let alreadyInAMatch = false;
				const refusals = [];
				results.forEach((result, index) => {
					success(result);
					if(result && result.hadError) {
						const errorData = (result.error && result.error.error_data) || {};
						if(errorData.in_match) {
							mostImportantError = 'You are already in a match';
							alreadyInAMatch = true;
						} else if(!alreadyInAMatch) {
							mostImportantError = result.error.error;
						}
						refusals.push({
							ladderId: playOptions[index].ladderId,
							message: result.error.error,
							duplicateSearch: Boolean(errorData.duplicate_search),
							searchId: errorData.search_id || null,
						});
					}
				});
				if(mostImportantError && onSearchErrors && !alreadyInAMatch) {
					onSearchErrors(refusals);
				} else if(alreadyInAMatch) {
					showToast({ content: mostImportantError });
					dispatch(returnToMatchView());
				} else if(mostImportantError) {
					showToast({ kind: 'warning', content: mostImportantError });
				} else {
					for(let result of results) {
						Dashboard.performOpenSearchUpdate(result);
					}
					dispatch(returnToMatchmaking());
				}
			})
			.catch((error) => {
				Request.generalJsonError(error);
				throw error;
			})
			.finally(finished);
	}

};